document.addEventListener('DOMContentLoaded', () => {
  function getSelectedSKU() {
    const activeImage = document.querySelector('.product-media--root[data-active="true"] img[alt]');
    return activeImage?.getAttribute('alt')?.trim().toUpperCase() || null;
  }

  function updateImagesBySKU(selectedSKU = null) {
    if (!selectedSKU) {
      selectedSKU = getSelectedSKU();
    }
    if (!selectedSKU) return;

    // 🎯 Atualiza imagens principais (desktop)
    document.querySelectorAll('.main-product--desktop .product-media--root').forEach(container => {
      const img = container.querySelector('img[alt]');
      const alt = img?.getAttribute('alt')?.trim().toUpperCase();

      if (alt === selectedSKU) {
        container.removeAttribute('hidden');
        container.setAttribute('data-active', 'true');
      } else {
        container.setAttribute('hidden', 'true');
        container.setAttribute('data-active', 'false');
      }
    });

    // 📱 Atualiza thumbs (mobile) sem quebrar carrossel
    document.querySelectorAll('.product-media--thumbs-wrapper .product-media--thumb').forEach(thumb => {
      const img = thumb.querySelector('img[alt]');
      const alt = img?.getAttribute('alt')?.trim().toUpperCase();

      if (alt === selectedSKU) {
        thumb.style.display = ''; // mostra
        thumb.setAttribute('data-active', 'true');
      } else {
        thumb.style.display = 'none'; // esconde
        thumb.setAttribute('data-active', 'false');
      }
    });
  }

  // Inicial
  updateImagesBySKU();

  // Observa alterações
  const observer = new MutationObserver(() => {
    setTimeout(updateImagesBySKU, 50);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'value', 'data-selected'],
  });

  // Detecta mudança de input (variações)
  document.querySelectorAll('.swatch--input').forEach(input => {
    input.addEventListener('change', () => {
      setTimeout(updateImagesBySKU, 50);
    });
  });

  // Força atualização manual ao clicar na thumb (mobile)
  document.querySelectorAll('.product-media--thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const img = thumb.querySelector('img[alt]');
      const alt = img?.getAttribute('alt')?.trim().toUpperCase();
      if (alt) {
        updateImagesBySKU(alt);
      }
    });
  });
});
